import React, { useEffect, useState } from 'react';
import Layout from '../../../../app/Layout';
import HeaderContent from '../../General/HeaderContent';
import Breadcrumb from '../../General/Breadcrumb';
import SpinnerLoading from '../../../components/Spinners/SpinnerLoading';
import ModalLarge from '../../../components/Modals/ModalLarge/ModalLarge';
import ListaReportesTutor from '../../../components/ListaReportesTutor';
import ListaEncuestasDocente from '../../../components/ListaEncuestasDocente';
import SimpleSelect from '../../../components/plugins/SimpleSelect';
import { Link, useParams } from 'react-router-dom';
import { Badge, Button, Dropdown, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch, faCalendarAlt, faBoxOpen,
  faClipboardList, faChalkboardTeacher, faUserGraduate,
  faExchangeAlt, faTrashAlt, faCog,
} from '@fortawesome/free-solid-svg-icons';

import { connect } from 'react-redux';
import { obtenerEventosTutor, eliminarEventosTutor, reasignarTutor, obtenerTutoresSelect } from '../../../../actions/tutoresActions';
import { obtenerEncuestasReportesTutor, obtenerEncuestaDocente } from '../../../../actions/encuestasAction';

const extraerAnio = nombre => {
  const match = nombre && nombre.match(/\b(20\d{2})\b/);
  return match ? match[1] : null;
};

const TutoresInfo = props => {
  const { idTutor } = useParams();
  const {
    eventosTutor, usuario, selectTutores,
    obtenerEventosTutor, eliminarEventosTutor,
    reasignarTutor, obtenerTutoresSelect,
    obtenerEncuestasReportesTutor, obtenerEncuestaDocente,
  } = props;

  const [busqueda,      setBusqueda]      = useState('');
  const [anioSel,       setAnioSel]       = useState('');
  const [showModal,     setShowModal]     = useState(false);
  const [listaReporte,  setListaReporte]  = useState(null);
  const [showReasignar, setShowReasignar] = useState(false);
  const [eventoActivo,  setEventoActivo]  = useState(null);
  const [nuevoTutor,    setNuevoTutor]    = useState(null);

  useEffect(() => {
    obtenerEventosTutor(idTutor);
    obtenerTutoresSelect();
  }, []);

  const eventos = eventosTutor?.eventos_tutor || [];

  const anios = [...new Set(
    eventos.map(ev => extraerAnio(ev.nombre_proyecto)).filter(Boolean)
  )].sort((a, b) => b - a);

  const eventosFiltrados = eventos.filter(ev => {
    const coincideBusqueda = ev.nombre_proyecto?.toLowerCase().includes(busqueda.toLowerCase());
    const coincideAnio     = !anioSel || extraerAnio(ev.nombre_proyecto) === anioSel;
    return coincideBusqueda && coincideAnio;
  });

  const abrirEncuestaTutor = (evento) => {
    setListaReporte(<ListaReportesTutor />);
    obtenerEncuestasReportesTutor(evento.id_tutor_proyecto);
    setShowModal(true);
  };

  const abrirEncuestaDocente = (evento) => {
    setListaReporte(<ListaEncuestasDocente id_proyecto={evento.id_proyecto} />);
    obtenerEncuestaDocente(evento.id_proyecto);
    setShowModal(true);
  };

  const abrirReasignar = (evento) => {
    setEventoActivo(evento);
    setNuevoTutor(null);
    setShowReasignar(true);
  };

  const confirmarReasignacion = async () => {
    if (!nuevoTutor || !eventoActivo) return;
    const ok = await reasignarTutor(eventoActivo.id_proyecto, nuevoTutor.value, eventoActivo.id_tutor);
    if (ok) setShowReasignar(false);
  };

  const esAdmin        = usuario.id_tp_nivel_usuario !== '7';
  const puedeReasignar = ['1', '5'].includes(usuario.id_tp_nivel_usuario);

  return (
    <Layout>
      <HeaderContent
        title="Tutor"
        subItem={`${eventosTutor.nombre_usuario || ''} ${eventosTutor.apellido_usuario || ''}`}
      />
      <Breadcrumb
        link={[
          { url: '/inicio',   nombre: 'Inicio',        icon: 'fas fa-home' },
          { url: '/tutores',  nombre: 'Tutores' },
          { url: '',          nombre: 'Tutor detalles' },
        ]}
      />

      <div className="tutores-info">
        <SpinnerLoading loading={props.loading}>

          {/* Filtros */}
          <div className="box p-4 mb-3">
            <div className="row align-items-end">
              <div className="col-md-6 mb-2 mb-md-0">
                <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
                  <FontAwesomeIcon icon={faSearch} className="mr-1 text-muted" />
                  Buscar producto
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Escribe el nombre del producto..."
                  value={busqueda}
                  onChange={e => setBusqueda(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-2 mb-md-0">
                <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
                  <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" />
                  Año
                </label>
                <select
                  className="form-control"
                  value={anioSel}
                  onChange={e => setAnioSel(e.target.value)}
                >
                  <option value="">Todos los años</option>
                  {anios.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
              </div>
              <div className="col-md-3 d-flex align-items-center" style={{ paddingTop: 22 }}>
                <Badge variant="secondary" style={{ fontSize: 14, marginRight: 8, padding: '5px 10px' }}>
                  {eventosFiltrados.length} / {eventos.length}
                </Badge>
                {(busqueda || anioSel) && (
                  <button
                    className="btn btn-link p-0"
                    style={{ fontSize: 14 }}
                    onClick={() => { setBusqueda(''); setAnioSel(''); }}
                  >
                    Limpiar
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Tabla */}
          <div className="box">
            <div className="box-body p-0">
              {eventosFiltrados.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <FontAwesomeIcon icon={faBoxOpen} style={{ fontSize: 36, display: 'block', margin: '0 auto 10px' }} />
                  <p>No se encontraron productos.</p>
                  <button className="btn btn-link btn-sm" onClick={() => { setBusqueda(''); setAnioSel(''); }}>
                    Ver todos
                  </button>
                </div>
              ) : (
                <div className="table-responsive" style={{ overflow: 'visible' }}>
                  <table className="table table-bordered table-hover mb-0">
                    <thead className="thead-light">
                      <tr style={{ fontSize: 15 }}>
                        <th className="text-center" style={{ width: 50 }}>#</th>
                        <th>Producto</th>
                        <th className="text-center" style={{ width: 80 }}>Año</th>
                        <th className="text-center" style={{ width: 100 }}>Sesiones</th>
                        <th className="text-center" style={{ width: 100 }}>Estado</th>
                        <th className="text-center">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventosFiltrados.map((ev, i) => {
                        const anio = extraerAnio(ev.nombre_proyecto);
                        return (
                          <tr key={ev.id_proyecto} style={{ fontSize: 15 }}>
                            <td className="text-center align-middle">{i + 1}</td>
                            <td className="align-middle" style={{ maxWidth: 450, wordBreak: 'break-word', whiteSpace: 'normal' }}>
                              {ev.nombre_proyecto}
                              {ev.inhouse == 1 && (
                                <Badge variant="warning" className="ml-2" style={{ fontSize: 11 }}>In House</Badge>
                              )}
                            </td>
                            <td className="text-center align-middle">
                              {anio
                                ? <Badge variant="info" style={{ fontSize: 13 }}>{anio}</Badge>
                                : <span className="text-muted">—</span>
                              }
                            </td>
                            <td className="text-center align-middle">
                              <span>{ev.total_sesiones ?? '—'}</span>
                            </td>
                            <td className="text-center align-middle">
                              {ev.id_tp_estado == 1
                                ? <Badge variant="success" style={{ fontSize: 13 }}>Activo</Badge>
                                : <Badge variant="secondary" style={{ fontSize: 13 }}>Inactivo</Badge>
                              }
                            </td>
                            <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
                              <Dropdown className="d-inline mr-1">
                                <Dropdown.Toggle variant="info" id={`opciones-${ev.id_proyecto}`}>
                                  <FontAwesomeIcon icon={faCog} className="mr-1" />
                                  Opciones
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item as={Link} to={`/tutor/eventos/${ev.id_proyecto}/${ev.id_tutor_proyecto}/encuestas`}>
                                    <FontAwesomeIcon icon={faClipboardList} className="mr-2 text-primary" />
                                    Encuestas discentes
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => abrirEncuestaTutor(ev)}>
                                    <FontAwesomeIcon icon={faChalkboardTeacher} className="mr-2 text-info" />
                                    Encuesta tutor
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => abrirEncuestaDocente(ev)}>
                                    <FontAwesomeIcon icon={faUserGraduate} className="mr-2 text-secondary" />
                                    Encuesta docente
                                  </Dropdown.Item>
                                  {puedeReasignar && (
                                    <Dropdown.Item onClick={() => abrirReasignar(ev)}>
                                      <FontAwesomeIcon icon={faExchangeAlt} className="mr-2 text-warning" />
                                      Reasignar tutor
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                              {esAdmin && (
                                <Button
                                  variant="danger"
                                  onClick={() => eliminarEventosTutor(ev.id_tutor_proyecto)}
                                >
                                  <FontAwesomeIcon icon={faTrashAlt} />
                                </Button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

        </SpinnerLoading>
      </div>

      {/* Modal encuestas */}
      <ModalLarge show={showModal} updateModalLarge={setShowModal} title="Reportes">
        {listaReporte}
      </ModalLarge>

      {/* Modal reasignar */}
      <Modal show={showReasignar} onHide={() => setShowReasignar(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16 }}>Reasignar tutor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted" style={{ fontSize: 13 }}>
            Producto: <strong>{eventoActivo?.nombre_proyecto}</strong>
          </p>
          <p style={{ fontSize: 13 }}>Selecciona el nuevo tutor:</p>
          <SimpleSelect
            options={selectTutores}
            getSelection={setNuevoTutor}
            placeholder="Buscar tutor..."
          />
          <p className="text-warning mt-3" style={{ fontSize: 12 }}>
            <FontAwesomeIcon icon={faExchangeAlt} className="mr-1" />
            El tutor actual será reemplazado. Los reportes, asistencias y registros previos se conservan.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowReasignar(false)}>Cancelar</Button>
          <Button variant="warning" size="sm" disabled={!nuevoTutor} onClick={confirmarReasignacion}>
            <FontAwesomeIcon icon={faExchangeAlt} className="mr-1" />
            Confirmar reasignación
          </Button>
        </Modal.Footer>
      </Modal>

    </Layout>
  );
};

const mapStateToProps = state => ({
  loading:       state.tutores.loading,
  usuario:       state.usuario.usuario,
  eventosTutor:  state.tutores.eventosTutor,
  selectTutores: state.tutores.selectTutores,
});

const mapDispatchToProps = {
  obtenerEventosTutor,
  eliminarEventosTutor,
  reasignarTutor,
  obtenerTutoresSelect,
  obtenerEncuestasReportesTutor,
  obtenerEncuestaDocente,
};

export default connect(mapStateToProps, mapDispatchToProps)(TutoresInfo);
